// Modules
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import compose from 'lodash/flowRight';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import cx from 'classnames';
import { asyncConnect } from 'redux-connect';
import Link from 'react-router/lib/Link';
import withPageWrapper from '../../containers/PageContainer/PageContainer';
// Helpers
import appendLocale from '../../helpers/appendLocale';
import { shareUrl } from '../../constants';
import multiLanguageTags from '../../helpers/multiLanguageHeadTags';
import { getLocaleFromRoute } from '../../helpers/localization';
// Redux
import { receiveArticles } from '../../redux/modules/articles';
// Styles
import styles from './ArticlesPage.scss';

class ArticlesPage extends Component {
  renderArticle = (element, isFirst) => {
    const img = element.thumbnail;

    return (
      <Link to={appendLocale(this.props.locale, `/articles/${element.id}`)} key={element.id} className={styles.article}>
        <div style={{ backgroundImage: `url(${img})` }} className={styles.picture} />
        <div className={styles.textPart}>
          <div className={styles.textWrapper}>
            <div className={styles.title}>{element.title}</div>
            <div className={styles.description}>{element.description}</div>
          </div>
        </div>
      </Link>
    );
  };

  renderHelmet = () => {
    const { route, locale } = this.props;
    const multiLanguage = multiLanguageTags(route, locale);
    return (
      <Helmet
        titleTemplate={this.props.translate('title', 'titleTemplate')()}
        title={this.props.translate('helmet', 'articlesTitle')()}
        meta={[
          { property: 'og:url', content: `${shareUrl}${route}` },
          { property: 'og:title', content: `${this.props.translate('helmet', 'articlesTitle')} | \u202BOnMap` },
          { property: 'og:description', content: this.props.translate('helmet', 'articlesDescription') },
          { property: 'x:title', content: `${this.props.translate('helmet', 'articlesTitle')} | \u202BOnMap` },
          { property: 'x:description', content: this.props.translate('helmet', 'articlesDescription') },
          { property: 'x:image:alt', content: this.props.translate('title', 'articles') },
          { name: 'description', content: this.props.translate('helmet', 'articlesDescription') },
          ...((this.props.locale === 'fr') ? [{ name: 'robots', content: 'noindex,nofollow' }] : [])
        ]}
        link={[
          ...multiLanguage,
          { rel: 'canonical', href: `${shareUrl}${route}` }
        ]}
      />
    );
  };

  renderH1 = () => (
    <h1 className={styles.pageTitle}>
      {this.props.translate('title', 'articles')}
    </h1>
  );

  render() {
    const { articles } = this.props;
    if (articles.length) {
      return (
        <div className={cx(styles.articlesWrapper, 'pageHeight')}>
          {this.renderHelmet()}
          {this.renderH1()}
          {this.renderArticle(articles[0], 'isFirst')}
          <div className={styles.articlesBlock}>
            {articles.slice(1).map(element => this.renderArticle(element))}
          </div>
        </div>
      );
    } return <div className="pageHeight" />;
  }
}

ArticlesPage.propTypes = {
  isMobile: PropTypes.bool,
  articles: PropTypes.array,
  locale: PropTypes.string,
  translate: PropTypes.func,
  route: PropTypes.any
};

const asyncData = [{
  key: 'articles',
  promise: ({ store, location: { pathname } }) => {
    const locale = getLocaleFromRoute(pathname);
    if (locale === 'fr') {
      return store.dispatch(receiveArticles('en'));
    }
    return store.dispatch(receiveArticles(locale));
  }
}];

const mapStateToProps = state => ({
  articles: state.articles.articles,
  translate: getLang(state.lang, 'static')
});

export default compose(
  asyncConnect(asyncData),
  connect(mapStateToProps)
)(withPageWrapper(ArticlesPage));
